import { SliderBottomRightArrow } from './SliderBottomRightArrow';

export const Slider = {
  SliderBottomRightArrow,
};
